import { render, staticRenderFns } from "./ChangeOrgUserTag.vue?vue&type=template&id=34472479&scoped=true";
import script from "./ChangeOrgUserTag.vue?vue&type=script&lang=js";
export * from "./ChangeOrgUserTag.vue?vue&type=script&lang=js";
import style0 from "./ChangeOrgUserTag.vue?vue&type=style&index=0&id=34472479&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "34472479", null);
export default component.exports;